module.exports = __webpack_public_path__ + "img/bank-card-line.fabb185e.svg";